class archiveTicketTemplate {
    constructor($state, $http, alert, $translate) {
        this.key = 'archive-pdf-ticket';
        this.title = 'Delete';
        this.level = 'highlight';
        this.icon = 'trash-alt';
        this.order = 15;
        this.state = $state;
        this.http = $http;
        this.alert = alert;
        this.translate = $translate;
    }

    action(model, vm) {

        const translatedValue = (path, params) => {
            return this.translate.instant(`tickets.ask-to-delete-ticket.${path}`, params);
        };

        this.alert.animatedAlert(
            translatedValue('title'),
            translatedValue('content', {ticket_name: vm.model.name}),
            'attention',
            {
                confirmButtonText: translatedValue('confirm'),
                cancelButtonText: translatedValue('cancel'),
            },
        )
            .then(() => {
                this.http.put(`tickets/templates/${vm.model.id}/archive`, {
                    data: {force: vm.model.archived}
                })
                    .then(() => {
                        this.state.go('app.tickets.templates.edit', {id: vm.model.id}, {reload: true});
                    }, err => this.alert.handle(err));
            }, err => this.alert.handle(err));
    }

}

angular
    .module('festzelt-os.modules.tickets')
    .factory('archiveTicketTemplate', [
        '$state',
        '$http',
        'Alert',
        '$translate',
        ($state, $http, Alert, $translate) => new archiveTicketTemplate($state, $http, Alert, $translate)
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/tickets/templates/workflows/details/archive-ticket-template.js